const ITEMS = [
  'Clarinetto',
  'Clarinetto Piccolo',
  'Corno di Bassetto',
  'Clarinetto Basso',
  'Violino',
  'Musica da Camera',
  'Canto Lirico',
  'Novembre 2026 — Giugno 2027',
];

const MarqueeRibbon = () => {
  const row = (
    <>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center shrink-0">
          <span className="font-display italic text-2xl sm:text-3xl text-[#f3e5ab]/80 px-8 whitespace-nowrap">
            {item}
          </span>
          <span className="w-1.5 h-1.5 rounded-full bg-[#d4af37]/60 shrink-0" />
        </span>
      ))}
    </>
  );

  return (
    <div
      data-testid="marquee-ribbon"
      className="relative z-10 border-y border-[#d4af37]/15 bg-[#0a1216]/60 backdrop-blur-sm py-5 overflow-hidden"
    >
      <div className="marquee-track">
        <div className="flex shrink-0">{row}</div>
        <div className="flex shrink-0" aria-hidden="true">
          {row}
        </div>
      </div>
    </div>
  );
};

export default MarqueeRibbon;
